var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { batchEnd, batchStart, disposeBindingReactions, releaseBindingReactions, } from './reaction';
import { untracked } from './untracked';
import { isFn } from './checkers';
import { ReactionStack } from './environment';
export var autorun = function (tracker, name) {
    if (name === void 0) { name = 'AutoRun'; }
    var reaction = function () {
        if (ReactionStack.indexOf(reaction) === -1) {
            releaseBindingReactions(reaction);
            try {
                ReactionStack.push(reaction);
                batchStart();
                if (isFn(tracker))
                    tracker();
            }
            finally {
                batchEnd();
                ReactionStack.pop();
            }
        }
    };
    reaction._name = name;
    reaction();
    return function () {
        disposeBindingReactions(reaction);
    };
};
export var reaction = function (tracker, subscriber, options) {
    var realOptions = __assign({ name: 'Reaction' }, options);
    var value = {};
    var tracked = {};
    var dirty = {};
    var dirtyCheck = function () {
        if (isFn(realOptions.equals))
            return !realOptions.equals(value.oldValue, value.currentValue);
        return value.oldValue !== value.currentValue;
    };
    return autorun(function () {
        value.currentValue = tracker();
        dirty.current = dirtyCheck();
        if (dirty.current && tracked.current) {
            untracked(function () {
                if (isFn(subscriber))
                    subscriber(value.currentValue);
            });
        }
        value.oldValue = value.currentValue;
        tracked.current = true;
    }, realOptions.name);
};
